module.exports = __webpack_public_path__ + "static/media/400335_01.28f3f77e.png";